export default __webpack_public_path__ + "static/pro@2x-c78866928d0a7c99f3cca554e91c7597.webp";